define.alias("ember-composable-helpers/helpers/pipe-action", "calendar/helpers/pipe-action");